import * as SlotFamilyType from '../../../constants/SlotFamilyType';
import slotFamiliesConfig from './slot-families-config.json';
export default function slotFamilyProvider(sportId, slotType) {
    //slotType => slotFamily
    var slotFamilies = slotFamiliesConfig[sportId];
    if (slotFamilies === undefined) {
        return SlotFamilyType.TWO_WAY;
    }
    return slotFamilies[slotType] || SlotFamilyType.TWO_WAY;
}



// WEBPACK FOOTER //
// ./src/components/grid/providers/SlotFamilyProvider.js